import { EPortalRumEvents, logPortalRumInfo } from '@/lib/coralogix';
import { ESessionStorageKeys, ESource } from '@/lib/enums';
import { webStorageUtil } from '@/state/webStorage.state.service';

interface IHandleTopbarLoginClickProps {
  isOtpLoggingIn: boolean;
  setIsLoginModalOpen: (isOpen: boolean) => void;
}

export const handleTopbarLoginClick = ({
  isOtpLoggingIn,
  setIsLoginModalOpen,
}: IHandleTopbarLoginClickProps): void => {
  if (isOtpLoggingIn) {
    logPortalRumInfo(EPortalRumEvents.PORTAL_LOGIN_CLICK_IGNORED, {
      reason: 'otp-logging-in',
    });
    return;
  }

  setIsLoginModalOpen(true);
  webStorageUtil.set(ESessionStorageKeys.SOURCE, ESource.LOGIN);
};
